import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/authContext";

/**
 * ProtectedRoute — redirects unauthenticated users to /signin?next=<current-path>.
 * `roles` (optional): array of user roles that are allowed to see this route.
 */
export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const location = useLocation();

    // Still checking session
    if (user === null) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center font-mono text-xs text-[#666]" data-testid="auth-checking">
                Checking session…
            </div>
        );
    }

    if (!user) {
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/signin?next=${next}`} replace />;
    }

    if (roles && roles.length && !roles.includes(user.role) && user.role !== "admin") {
        return (
            <div className="p-10 text-center" data-testid="auth-forbidden">
                <div className="font-display font-black uppercase text-3xl text-[#ff4400]">Access denied</div>
                <div className="mt-2 text-sm text-[#a3a3a3]">Your account does not have permission to view this page.</div>
            </div>
        );
    }

    return children;
}
